import React from 'react';
import { Link } from 'react-router-dom';

export const Blog = ({mypost})=>{
    return (
  	<>
    <div className="card mb-0 my-0 ">  
    <div className="card-body">
    <h5 className="card-title">{mypost.title}</h5>
    <p className="card-text">
    {mypost.content.split(' ').slice(0,52).join(' ') + '...read more'}
    </p>
    <Link to={"/blog/"+mypost.slug} className="float-left sbtn next-arrow-btn green-btn">
    View Blog
    </Link>
    </div>
    </div>
    <br/>
  	</>
)}